import React from 'react';

/**
 * BackArrow - SVG back arrow icon matching Gesture Consumer App chevronLeft
 * Matches consumer app's Chevron_Left.svg exactly: 24x24px, path d="M15 19L8 12L15 5"
 * Stroke color controlled via CSS to match consumer app styling (black)
 */
const BackArrow = ({ className, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M15 19L8 12L15 5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BackArrow;